// Base components
export * from './components/AgentAvatar';
export * from './components/base/Icon';
export * from './components/base/Text';
export * from './components/forms/Button';

// Form components
export * from './components/AddPaymentMethodPanel';
export * from './components/ClearableSelect';
export * from './components/custom-fields';
export * from './components/DeliveryCadenceEditor';
export * from './components/form/FieldDefinitionEditor';
export * from './components/forms/ButtonGroup';
export * from './components/forms/CatalogValueSelect';
export * from './components/forms/CatalogValueTypeahead';
export * from './components/forms/Checkbox';
export * from './components/forms/CodeEditor';
export * from './components/forms/Combobox';
export * from './components/forms/CompanySelector';
export * from './components/forms/ContextAwareMergeVariableDropdown';
export * from './components/forms/DatePicker';
export * from './components/forms/DateRangePicker';
export * from './components/forms/DateRangePillSelector';
export * from './components/forms/DiscountInput';
export * from './components/forms/FieldValueInput';
export * from './components/forms/FileDropZone';
export * from './components/forms/form-renderer';
export * from './components/forms/FormField';
export * from './components/forms/FormRow';
export * from './components/forms/FormSection';
export * from './components/forms/Input';
export * from './components/forms/Label';
export * from './components/forms/MaskedInput';
export * from './components/forms/MergeVariableDropdown';
export * from './components/forms/ModernDateRangePicker';
export * from './components/forms/MultiSelect';
export * from './components/forms/PhoneInput';
export * from './components/forms/PlainTextTemplateEditor';
export * from './components/forms/QuantityInput';
export * from './components/forms/QuantitySelector';
export * from './components/forms/RawDiscountInput';
export * from './components/forms/RawFreightInput';
export * from './components/forms/ReadOnlyFieldValue';
export * from './components/forms/RecipientBucketEditor';
export * from './components/forms/RecurrenceSelector';
export * from './components/forms/RichTextEditor';
export * from './components/forms/Select';
export * from './components/forms/SelectOptionsEditor';
export * from './components/forms/SelectSearch';
export * from './components/forms/SignaturePad';
export * from './components/forms/SingleSelect';
export * from './components/forms/StarRating';
export * from './components/forms/StyledQuantitySelector';
export * from './components/forms/TemplateVariableEditor';
export * from './components/forms/TermsCodeSelector';
export * from './components/forms/TextArea';
export * from './components/forms/TextInput';
export * from './components/forms/ThemeAwareColorTiles';
export * from './components/forms/TimeInput';
export * from './components/forms/Toggle';
export * from './components/forms/Typeahead';
export * from './components/forms/VariableDefinitionEditor';
export * from './components/forms/VariableMapping';
export * from './components/forms/VoiceProfileSelect';
export * from './components/forms/WarehouseSelector';
export * from './components/forms/WarehouseSingleSelect';

// Entity selectors
export * from './components/forms/entity-selectors';

export * from './components/NoFeeReasonHint';
export * from './components/PaymentMethodForm';
export * from './components/shop/BaseShopActions';
export * from './components/shop/ShopPriceInput';

// Address components
export * from './components/address/AddressDropdown';
export * from './components/address/AddressSelector';

// Overlay components
export { default as GenericPopover } from './components/common/Popover';
export * from './components/invoices/CreateCreditMemoDrawer';
export * from './components/invoices/CreateInvoiceDrawer';
export * from './components/invoices/LinkInvoiceOrderModal';
export * from './components/invoices/UnlinkedInvoiceBanner';
export * from './components/LocationItemsSidebar';
export * from './components/overlays/BottomSheet';
export * from './components/overlays/Dropdown';
export * from './components/overlays/FloatingOverlay';
export * from './components/overlays/Modal';
export * from './components/overlays/Popover';
export * from './components/overlays/Sidebar';
export * from './components/overlays/Tooltip';
export * from './components/payments';
export * from './components/quotes/CreateQuoteDrawer';
export * from './components/settings/BiometricSignInSetting';
export * from './components/settings/InstanceSignInEditor';
export * from './components/settings/SignInPasswordOverrideToggle';
export * from './navigation/NavigationGuard';
export * from './navigation/navigationGuardRegistry';

// Dialog components
export * from './components/dialogs/AddToRouteDialog';
export * from './components/dialogs/ClientListEditorModal';
// Shared hand-picked list editor + adapter types (client lists, item lists — PD-15839)
export * from './components/dialogs/ConfirmDialog';
export * from './components/dialogs/DeleteConfirmationModal';
export * from './components/dialogs/DeleteRecurringChoiceDialog';
export * from './components/dialogs/EditRecurringChoiceDialog';
export * from './components/dialogs/MoveRecurringChoiceDialog';
export * from './components/dialogs/TaskActionDialogs';
export * from './components/dialogs/TaskCompleteSidebar';
export * from './components/dialogs/TaskDialog';
export * from './components/dialogs/TaskViewModal';
export * from './components/dialogs/UnsavedChangesDialog';
export * from './components/entity-lists/entity-list.types';
export * from './components/entity-lists/EntityListEditorSidebar';
export * from './components/entity-lists/EntityListMembershipCard';

// Layout components
export * from './command-palette';
export * from './components/branding/TenantAttributionHydrator';
export * from './components/layout/BrandAttributionFooter';
export * from './components/layout/ComponentHeader';
export * from './components/layout/Container';
export * from './components/layout/DensityScope';
export * from './components/layout/FilterSidebar';
export * from './components/layout/Grid';
export * from './components/layout/HeaderActions';
export * from './components/layout/HeaderFilterTray';
export * from './components/layout/PageHeader';
export * from './components/layout/PageShell';
export * from './components/layout/PageTitle';
export * from './components/layout/ReportPageHeader';
export * from './components/layout/SettingsPage';
export * from './components/layout/StickyActionBar';
export * from './components/layout/TopBar';
export {
	canOpenSetting,
	findSettingForPath,
	getVisibleSettingsGroups,
	settingPath,
} from './services/settingsAccess';

// Display components
export * from './components/ActiveAnnouncementsBanner';
export * from './components/CachedImage';
export * from './components/charts/ChartTooltip';
export * from './components/charts/SparklineTooltip';
export * from './components/display/AgentActionsBadge';
export * from './components/display/AgentActionsDropdown';
export * from './components/display/AreaChart';
export * from './components/display/Badge';
export * from './components/display/BadgeSummary';
export * from './components/display/ZoneCard';
// Distribution-module status pill — consolidates the 3 hand-rolled
// status→variant mappings into one shared component. See P1.2.
export { StatusPill } from './components/display/StatusPill';
// Live-polling heartbeat indicator (P1.4). Green pulsing dot when polling
// succeeded recently, red on error, gray when idle. Pairs with auto-polling
// screens like LiveBoardPage.
export * from './components/display/BarChart';
export * from './components/display/CallMethodModal';
export * from './components/display/Card';
export * from './components/display/CardContent';
export * from './components/display/ChatDisplay';
export * from './components/display/ClickToDialPhone';
export * from './components/display/ClickToEmail';
export * from './components/display/CollapsibleSection';
export * from './components/display/ComboChart';
export * from './components/display/ConversationSidebar';
export * from './components/display/DataField';
export * from './components/display/DeviceSelectionModal';
export * from './components/display/EmailMethodModal';
export * from './components/display/EnvironmentBanner';
export * from './components/display/InlineEditableCell';
export * from './components/display/KpiCard';
export * from './components/display/KpiCardGrid';
export * from './components/display/LineChart';
export { LiveStatusDot } from './components/display/LiveStatusDot';
export * from './components/display/LoadingSpinner';
export * from './components/display/LocationFillBars';
export * from './components/display/NotFound';
export * from './components/display/PieChart';
export { RelatedEntitiesCard } from './components/display/RelatedEntitiesCard';
export * from './components/display/ReportCsvExportButton';
export * from './components/display/RingCentralUserAuthModal';
export * from './components/display/SparklineChart';
export * from './components/display/Table';
export * from './components/display/TablePaginationControls';
export * from './components/display/TemplatePreview';
export * from './components/display/ToolCallDisplay';
export * from './components/display/VonageExtensionSetupModal';
export * from './components/ImagePlaceholder';
export * from './components/promos';
export * from './components/ResilientImage';
export * from './components/storefront-widgets';
// PD-16339 — the media library's browser, detail panel, picker and upload hook.
export * from './components/media';
export * from './components/Tree';
export * from './contexts/WidgetExportContext';

// Image Viewer
export * from './components/ImageViewerModal';

// Activity Timeline components
export * from './components/activity-timeline';

// Entity Files components
export * from './components/entity-files';

// Record picker (shared "add clients/items" modal)
export * from './components/pickers/AvailableRecordsPicker';

// File Viewer components
export * from './components/file-viewer';

// Entity Notes components
export * from './components/entity-notes';

// Entity Watchers components
export * from './components/entity-watchers';

// Entity Tasks components
export * from './components/entity-tasks';
export * from './components/issues';

// Agent Widget components
export * from './components/agent-widget';

// Delegation components
export * from './components/delegation';

// Map components
export * from './components/maps';

// Scorecard components
export * from './components/scorecards';

// Theme components

// View Layout components
export * from './components/view-layouts';

// Filter components
export * from './components/filters';
export {
	FilterProvider,
	useFilter,
	useFilterContext,
} from './filters/context/FilterContext';
export { ReportFilterProvider } from './filters/ReportFilterProvider';
export { useContextAwareFilterOptions } from './filters/useContextAwareFilterOptions';
export { useMultipleFilters } from './filters/useMultipleFilters';

// Date range utilities from core
export { getDateRanges } from '@supply-mover-2-0/core';

// Auth components

// OAuth components
export * from './components/oauth';

// Navigation components
export * from './components/navigation/AppBackOriginTracker';
export * from './components/navigation/Breadcrumbs';
export * from './components/navigation/GroupedHeaderTabs';
export * from './components/navigation/HeaderTabs';
export * from './components/navigation/Link';
export * from './components/navigation/ListNavigationBar';
export * from './components/navigation/ListNavigationControls';
export * from './components/navigation/Navigation';
export * from './components/navigation/NavigationLink';
export * from './components/navigation/SelectableLink';
export * from './components/navigation/Tabs';
export * from './components/navigation/WizardStepper';

// Providers
export * from './providers/AgentChatDataProvider';
export * from './providers/DocumentLanguageSync';
export * from './providers/LayerProvider';
export * from './providers/ReliablePbxProvider';
export * from './providers/RingCentralProvider';
export * from './providers/TenantBrandingProvider';
export * from './providers/ThemeProvider';
export * from './providers/TranslationProvider';
export * from './providers/VonageProvider';

// Contexts
export {
	ConversationSidebarProvider,
	useConversationSidebar,
} from './contexts/ConversationSidebarContext';

// Hooks
export * from './hooks/useActivityDescription';
export * from './hooks/useActivityIdRouteSync';
export * from './hooks/useAgentDataRefresh';
export * from './hooks/useAllRoles';
export * from './hooks/useAppBack';
export * from './hooks/useAuthenticatedMediaUrl';
export * from './hooks/useBreadcrumbs';
// PD-15298 — receipt-printer connection state for components.
export * from './hooks/useBillingModes';
export * from './hooks/useCartMerge';
export * from './hooks/useCrossAccountDelivery';
export * from './hooks/useDefaultCreditLimit';
export * from './hooks/useEntityFileUpload';
export * from './hooks/useHeaderTabs';
export * from './hooks/useHeaderTabsListener';
export * from './hooks/useIdleTimeout';
export * from './hooks/useLicensingCompliance';
export * from './hooks/useListDetailNavigation';
export { useListModule } from './hooks/useListModule';
export type {
	DeleteModalConfig,
	DeleteModalProps,
	UseListModuleActions,
	UseListModuleConfig,
	UseListModuleState,
} from './hooks/useListModule';
export * from './hooks/useListNavigationState';
export * from './hooks/useMobileFeature';
export * from './hooks/useMobileFilters';
export * from './hooks/useNavigation';
export { usePageContextTracker } from './hooks/usePageContextTracker';
export * from './hooks/usePharmacyFeature';
export * from './hooks/useReceiptPrinter';
export * from './hooks/useRecordMastering';
export * from './hooks/useResponsive';
export * from './hooks/useSubmitGuard';
export * from './hooks/useVisibleKpis';
export * from './list-builder/components/saved-search/RoleSelector';

// Types
export * from './types/module-registry';
export type { HeaderTab } from './types/navigation';
export * from './types/theme.types';

// Services
export * from './components/chat-widget';
export {
	AgentReferenceService,
	agentReferenceService,
	findReferenceIndex,
	formatShortDateTime,
	getDefaultReference,
	groupReferencesBySession,
} from './services/AgentReferenceService';
export * from './services/appBackOrigin';
export * from './services/BreadcrumbService';
export * from './services/chat';
export { EntityReferenceService } from './services/EntityReferenceService';
export type {
	EntityReference,
	EntityReferenceRequest,
	EntitySummaryData,
	EntitySummaryItem,
	EntitySummaryResponse,
	EntityTypeSummary,
} from './services/EntityReferenceService';
export * from './services/HeaderTabService';
export { listCountCacheService } from './services/ListCountCacheService';
export { ListCountService } from './services/ListCountService';
export type { CountQueryFunction } from './services/ListCountService';
export { MessageService } from './services/MessageService';
// PD-15298 — BLE receipt-printer transport + connection state.
export type {
	ConversationMessage,
	MessagesResponse,
	ToolUsage,
} from './services/MessageService';
export * from './services/ModuleRegistry';
export type { RouteConfig } from './services/ModuleRegistry';
export * from './services/NavigationEventService';
export * from './services/NavigationUpdateService';
export * from './services/PermissionRefreshService';
export * from './services/ReceiptPrinterService';
export * from './services/SensorConfigService';
export * from './services/StickyHeaderService';
export * from './services/templateContextAnalyzer';
export {
	getCampaignContactStatusClasses,
	getCampaignStatusClasses,
	getChipColor,
	getChipColorByValue,
	getInvoiceStatusClasses,
	getLotStatusClasses,
	getOrderStatusClasses,
	getPaymentStatusClasses,
	getStockLevelClasses,
	themes,
	ThemeService,
	themeService,
} from './services/ThemeService';
export { Toast, ToastAPI } from './services/ToastService';
export type { ToastConfig, ToastType } from './services/ToastService';
export * from './services/variableTypeService';

// Export themes separately as they come from different files
export * from './hooks/useSettingsSection';
export * from './services/AIRegistry';
export { resolveContextValue } from './services/ContextValueResolver';
export { default as EnvironmentService } from './services/EnvironmentService';
export type { EnvironmentInfo } from './services/EnvironmentService';
export {
	OverlayProvider,
	OverlayRenderer,
	useOverlay,
} from './services/OverlayProvider';
export { OverlayService } from './services/OverlayService';
export type {
	OverlayConfig,
	OverlayPosition,
	OverlayState,
	OverlayType,
} from './services/OverlayService';
export { useSafeAreaHelper } from './services/SafeAreaHelper';
export type {
	SafeAreaHelper,
	SafeAreaPadding,
} from './services/SafeAreaHelper';
export { ScrollProvider, useScrollContext } from './services/ScrollContext';
export type {
	ScrollContextValue,
	ScrollProviderProps,
} from './services/ScrollContext';
export * from './services/settingsOrigin';
export * from './services/SettingsRegistry';
export * from './services/settingsSearch';
export type { Theme, ThemeColors, ThemeName } from './services/ThemeService';
import {
	tailwindClasses as internalTailwindClasses,
	type ThemeClassTokens,
} from './themes/tailwind-classes';

export { darkTheme } from './themes/dark-theme';
export { lightTheme } from './themes/light-theme';
export type { ThemeClassTokens } from './themes/tailwind-classes';

/**
 * The class tokens, reachable without a hook.
 *
 * `useThemeColors().classes` returns this same object, and inside a component
 * that remains the way to reach it. But a status map declared at module scope
 * — `{ active: '…', expired: '…' }` next to the component that uses it — has
 * no hook to call, which is why those maps are still written in raw palette
 * classes. They are the largest group left in the palette cleanup.
 *
 * Frozen on the way out. The internal object is shared with every consumer of
 * `getColors()`, and handing a mutable copy of it to every module in the repo
 * would widen a hazard that is already noted against ThemeService.
 */
export const tailwindClasses: Readonly<ThemeClassTokens> =
	Object.freeze<ThemeClassTokens>({ ...internalTailwindClasses });

// Overlays
export * from './components/overlays/ToastContainer';
export * from './components/receipts/printerConnectController';
export * from './components/receipts/PrinterConnectModal';
export * from './components/receipts/PrinterConnectModalHost';
export * from './components/receipts/ReceiptActions';

// Feedback
export { AccessDenied } from './components/feedback/AccessDenied';
export { AppUpdateBanner } from './components/feedback/AppUpdateBanner';
export { IdleTimeoutGuard } from './components/feedback/IdleTimeoutGuard';
export { NativeUpdateGate } from './components/feedback/NativeUpdateGate';
export { UpgradeRequired } from './components/feedback/UpgradeRequired';
export {
	AppUpdateService,
	type AppUpdateStateModel,
} from './services/AppUpdateService';
// Shared inline-notice primitive — consolidates ~8 sites that previously
// hand-rolled colored bg + border + icon blocks. See ui-polish-checklist.md P1.1.
export { Callout } from './components/feedback/Callout';

// Route Protection
export { ProtectedRoute } from './components/ProtectedRoute';

// Also export SafeAreaContainer and ContainerHeader from Container
export {
	ContainerHeader,
	SafeAreaContainer,
} from './components/layout/Container';

// ListBuilder components
export * from './list-builder';
export * from './list-builder/components/cart';
export { AgentActionsBadgeDisplay } from './list-builder/components/display/AgentActionsBadgeDisplay';

// List query utilities
export {
	createCountQueryFn,
	createListQueryFn,
} from './list-builder/utils/createListQueryFn';
export type {
	ListQueryFnConfig,
	ListQueryParams,
	ListQueryResponse,
} from './list-builder/utils/createListQueryFn';
export { wrapQueryService } from './list-builder/utils/wrapQueryService';
export type { WrapQueryServiceConfig } from './list-builder/utils/wrapQueryService';

// Automation
export * from './automation';

// AI components
export * from './ai-agent';

// Agent reference types
export type {
	AgentActionsBadgeCallbacks,
	AgentActionsBadgeProps,
	ConversationSidebarActions,
	ConversationSidebarProps,
	ConversationSidebarState,
	EntityAgentReference,
	SessionGroup,
} from './types/agent-references';

// Theme-aware color constants
export {
	DEFAULT_THEME_COLOR_ID,
	getNextAvailableColorId,
	getThemeAwareColorById,
	isLegacyHexColor,
	resolveThemeColor,
	THEME_AWARE_COLORS,
} from './constants/theme-aware-colors';
export type { ThemeAwareColor } from './constants/theme-aware-colors';

// Utility functions
export {
	getAvailableAutomationFilters,
	processAutomationFilters,
	validateAutomationFilters,
} from './utils/automation-filter-processor';
export {
	activeChatMemberCount,
	chatPeers,
	isGroupDm,
	isOneToOneDm,
	parseChatPrincipal,
	resolveChatConversationTitle,
	type ChatViewerIdentity,
} from './utils/chatConversationTitle';
export * from './utils/cn';
export {
	getConversationIcon,
	type ConversationIconType,
} from './utils/conversationIcons';
export { getCurrentTenantUserId } from './utils/current-user';
export {
	buildExportColumns,
	downloadBlob,
	downloadCsv,
	extractCsvRows,
} from './utils/report-csv-export';
export type { ReportExportColumn } from './utils/report-csv-export';
export { createSharedPoll, type SharedPoll } from './utils/sharedPoll';
export { resetShellSessionCaches } from './utils/shellSessionCaches';
export {
	convertTemplateVariablesToAvailableVariables,
	templateVariableToAvailableVariable,
} from './utils/templateVariableToAvailableVariable';
export * from './utils/theme-utils';

// Hooks
export * from './hooks/useBiometricLogin';
export { useDismissableLayer } from './hooks/useDismissableLayer';
export type {
	DismissableLayerOptions,
	DismissableLayerProps,
} from './hooks/useDismissableLayer';
export * from './hooks/useImageCache';
export * from './hooks/useIsKeyboardLikelyOpen';
export { getPageNumbers, usePagination } from './hooks/usePagination';
export { usePhoneInput } from './hooks/usePhoneInput';
export { usePopover } from './hooks/usePopover';
export type { PopoverOptions, PopoverPosition } from './hooks/usePopover';
export * from './hooks/useSidebarUnsavedChanges';
export * from './hooks/useTaskActions';
export * from './hooks/useUnsavedChanges';
export * from './hooks/useUrlModeParam';

// Icon utilities
export { getIconDefinition } from './components/IconSelector';

// Cart components
export { AddToCartButton } from './components/AddToCartButton';
export * from './components/cart';

// Cart reconciliation
export {
	CartDecision,
	CartDecisionModal,
} from './components/CartDecisionModal';
export { CartReconciliationModal } from './components/CartReconciliationModal';
export { CartReconciliationService } from './services/CartReconciliationService';
export * from './types/reconciliation.types';

// Email components
export * from './components/email-viewer';
export {
	EmailContentViewer,
	type EmailContentViewerProps,
} from './components/EmailContentViewer';
export {
	createEmptyEmailFormFieldsValue,
	EmailFormFields,
	type EmailFormFieldsValue,
} from './components/EmailFormFields';
export {
	buildEmailEntityDto,
	EmailModal,
	type EmailModalProps,
} from './components/EmailModal';

// AI conversation viewer (migrated from modules/ai-agents — DD.12.2.c)
export * from './components/conversation-viewer';

// SMS conversation viewer (DD.12.2.d) — bubble chat for messaging
// conversations. Used by the Communications-tab right-pane.
export * from './components/sms-viewer';

// Consolidated Communications panel (DD.12.2.e) — composes the four
// channel viewers above behind a unified list + filter UI.
export * from './components/communications-panel';

// Cart services
export { batchCartQueue } from './services/cart/batchCartQueue';
export { CartValidationManager } from './services/cart/CartValidationManager';
export type {
	AddressControls,
	AddressLicense,
	ContractPriceBreak,
	ControlledSubstanceCheck,
	OrderValidationState,
	ValidationContext,
	ValidationMessage,
	ValidationState,
} from './services/cart/CartValidationManager';
export { globalCartState } from './services/cart/globalCartState';
export { sharedCartState } from './services/cart/sharedCartState';
export {
	useCartOperations,
	usePendingPrice,
} from './services/cart/useCartOperations';

// Batch queue utilities
export { BatchQueue, createBatchQueue } from './utils/createBatchQueue';
export type {
	BatchContext,
	BatchOperation,
	BatchQueueConfig,
	PendingBatch,
} from './utils/createBatchQueue';

// Cart error message helper
export { getCartErrorMessage } from './utils/cart-error-message';
export { installNumberInputWheelGuard } from './utils/number-input-wheel-guard';

// Escaping for the few surfaces that must build markup as a string (map info
// windows, SVG pin data URLs).
export { escapeMarkup } from './utils/escape-markup';

// CSP-safe data URL → File conversion. Never `fetch()` a data URL: our
// connect-src does not allow `data:` (PD-16236).
export {
	dataUrlToFile,
	extensionForMimeType,
	parseDataUrl,
} from './utils/data-url-to-file';
export type { ParsedDataUrlModel } from './utils/data-url-to-file';

// Permission-gating helper components
export {
	NO_PRICE_MESSAGE,
	NoPermissionTooltip,
	OUT_OF_STOCK_MESSAGE,
} from './components/permissions/NoPermissionTooltip';

// RBAC Components
export * from './rbac';

export { AgentService } from './automation/services/agentService';
export type {
	Agent,
	Tool,
	VoiceProfile,
} from './automation/services/agentService';

// Shared state management
export * from './shared-state';

// Fulfillment components
export * from './components/fulfillment';

// License components
export {
	ClientComplianceBadge,
	formatLicenseCategoryLabel,
	getLicenseStatusBadgeVariant,
	isRegistryClientMatchReady,
	LicenseEditPanel,
	LicenseForm,
	LicenseReviewModal,
	LicenseSnapshotCard,
	LicenseStatusIndicator,
	LicenseSummaryModal,
	MatchCompareRow,
	MatchComparisonCard,
	matchConfidenceColorClass,
	RegistryClientMatchPlanPanel,
	RegistryMatchSearchModal,
	useRegistryClientMatchPlan,
	VerifiedRecordArtifact,
	type ClientComplianceBadgeProps,
	type EditPanelTab as LicenseEditPanelTab,
	type LicenseFormExisting,
	type LicenseFormSubmitPayload,
	type LicenseFormValues,
	type LicenseGoodStandingVerdict,
	type LicenseReviewModalProps,
	type LicenseSnapshotCardProps,
	type LicenseStatusIndicatorProps,
	type LicenseSummaryModalProps,
	type MatchCompareRowProps,
	type MatchComparisonCardProps,
	type RegistryClientMatchPlanPanelProps,
	type RegistryMatchSearchModalProps,
} from './components/licenses';

// Softphone — provider, hooks, store, and (eventually) UI shells
export * from './softphone';

// Notifications — top-bar bell tray + query-service client (DD.9.5.1)
export * from './notifications';

// Payments — cycle billing operations shared by the client Upcoming sub-tab
// and the tenant-wide pending cycle charges page (PD-15867)
export * from './payments/useCycleOccurrenceActions';

// Working Hours — shared editor + query service (DD.9.7.C)
export * from './working-hours';

// Client Hours — per-client opening-hours editor + query service
// (DD.9.7.E). Reads/writes the v1 client_hours table in place.
export * from './clients';

// Statement components (PD-14042)
export {
	StatementView,
	type StatementViewProps,
} from './components/statements/StatementView';

// Dashboard widget framework — drag-drop grid, widget container chrome,
// widget renderer dispatch. Used by both the CRM dashboard and the
// storefront homepage builder. Adapters for data-fetching + filter
// helpers are passed in by the consumer (CRM injects DashboardService /
// widgetDataStore; storefront injects its promo data adapter).
export * from './dashboard-widgets';

// ---------------------------------------------------------------------------
// Star-export disambiguation. Several names above are exported by more than
// one module (mostly because ./list-builder transitively re-exports all of
// @supply-mover-2-0/core); TypeScript silently DROPS an ambiguous name from
// the package surface, so each one below is pinned explicitly to the
// declaration package consumers actually use (verified against modules/ and
// apps/crm-web imports). The shadowed counterparts stay importable from
// their own package (@supply-mover-2-0/core) or module path.
// ---------------------------------------------------------------------------
export { formatRelativeTime } from './components/activity-timeline/formatRelativeTime';
export type { Task } from './components/dialogs/TaskDialog';
export type { CreateNoteData, UpdateNoteData } from './components/entity-notes';
export type { ContainerProps } from './components/layout/Container';
export { useHeaderTabsListener } from './hooks/useHeaderTabsListener';
// The form-editor FieldDefinition (pairs with FieldDefinitionEditor, used by
// modules/automation). The list-builder field descriptor of the same name
// must be imported from @supply-mover-2-0/core (modules/ecommerce — fixed in
// the modules phase).
export { FilterGroup } from './components/filters';
export type { FieldDefinition } from './components/form/FieldDefinitionEditor';
export { DATE_RANGE_OPTIONS } from './components/forms/DateRangePillSelector';
export type { DateRangeOption } from './components/forms/DateRangePillSelector';
export type { CreateInvoiceData } from './components/fulfillment';
export type { OAuthCallbackParams } from './components/oauth';
export { ScorecardComparison, ScorecardMetric } from './components/scorecards';
export type { FieldRenderer } from './components/view-layouts';
export type {
	ListNavigationState,
	NavigationWindow,
} from './hooks/useListNavigationState';
export * from './themes/density';
export type { AIAction } from './types/module-registry';
